import { useState } from "react";
import { Button, Card, Form, ListGroup } from "react-bootstrap";
import { BsSave } from "react-icons/bs";
import { FaTrashAlt } from "react-icons/fa";
import { FaCheck, FaRegCopy } from "react-icons/fa6";
import UseToggle from "../../../Hooks/UseToggle";
import { MdOutlineMarkEmailRead, MdPublishedWithChanges } from "react-icons/md";
import PermanentDeleteAccount from "./ModalCanvasPage/PermanentDeleteAccount";
import RegenerateSecretKey from "./ModalCanvasPage/RegenerateSecretKey";
import ChangeEmail from "./ModalCanvasPage/ChangeEmail";
import { VscEye, VscEyeClosed } from "react-icons/vsc";

const ProfileDetails = ({ auth, currentUserData, isDark }) => {
  const toggles = UseToggle();
  const [copiedField, setCopiedField] = useState(null);
  const [viewSecretKey, setViewSecretKey] = useState(false);

  const handleCopy = (e, text, field) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => {
      setCopiedField(null);
    }, 1500);
  };

  function maskWithXX(value) {
    return value
      .split("-")
      .map(part => "X".repeat(part.length))
      .join("-");
  }

  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3">
        <h5 className="fw-bold mb-1">Manage Your Account</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-50 m-auto py-3">
          <ListGroup className="mb-2">
            <ListGroup.Item action className="position-relative">
              <p className="m-0" style={{ fontSize: 12 }}>
                Email Address
              </p>
              <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
                {currentUserData?.email}
              </Form.Label>
              {copiedField === "emailAddress" ? (
                <FaCheck
                  className="position-absolute text-success"
                  title="Copied!"
                  style={{ fontSize: 14, top: 30, right: 10 }}
                />
              ) : (
                <FaRegCopy
                  className="position-absolute"
                  style={{ fontSize: 14, top: 30, right: 10, cursor: "pointer" }}
                  title="Copy Email Address"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(e, currentUserData?.email, "emailAddress");
                  }}
                />
              )}
              <Button
                variant="outline-primary mt-2"
                style={{ fontSize: 11 }}
                title="Change Email"
                onClick={(e) => {
                  e.stopPropagation();
                  toggles.setToggle2();
                }}
                className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
              >
                <MdOutlineMarkEmailRead /> Change Email
              </Button>
            </ListGroup.Item>
          </ListGroup>
          <ListGroup className="mb-2">
            <ListGroup.Item action className="position-relative">
              <p className="m-0" style={{ fontSize: 12 }}>
                Secret Key
              </p>
              <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
                {viewSecretKey ? currentUserData?.secretKey : maskWithXX(currentUserData?.secretKey)}
              </Form.Label>
              {viewSecretKey ? (
                <VscEye
                  className="position-absolute"
                  title="Hide"
                  style={{ fontSize: 18, top: 30, right: 40, cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setViewSecretKey(false);
                  }}
                />
              ) : (
                <VscEyeClosed
                  className="position-absolute"
                  style={{ fontSize: 18, top: 30, right: 40, cursor: "pointer" }}
                  title="Show"
                  onClick={(e) => {
                    e.stopPropagation();
                    setViewSecretKey(true);
                  }}
                />
              )}
              {copiedField === "secretKey" ? (
                <FaCheck
                  className="position-absolute text-success"
                  title="Copied!"
                  style={{ fontSize: 14, top: 30, right: 10 }}
                />
              ) : (
                <FaRegCopy
                  className="position-absolute"
                  style={{ fontSize: 14, top: 30, right: 10, cursor: "pointer" }}
                  title="Copy Secret Key"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopy(e, currentUserData?.secretKey, "secretKey");
                  }}
                />
              )}
              <Button
                variant="outline-primary mt-2"
                style={{ fontSize: 11 }}
                title="Regenerate Secret Key"
                onClick={(e) => {
                  e.stopPropagation();
                  toggles.setToggle1();
                }}
                className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
              >
                <MdPublishedWithChanges /> Regenerate Secret Key
              </Button>
            </ListGroup.Item>
          </ListGroup>
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <div className="hstack justify-content-between mb-2">
                <h6 className="m-0">{`Emergency Kit`}</h6>
                <Button
                  variant="outline-primary"
                  style={{ fontSize: 11 }}
                  title="Save Emergency Kit"
                  className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                >
                  <BsSave /> Save Emergency Kit
                </Button>
              </div>
              <p style={{ fontSize: 13 }} className="m-0">
                Your Emergency Kit contains information you’ll need to sign in to
                your Password Manager [PM] account.
              </p>
            </Card.Body>
          </Card>
          <div className="hstack justify-content-end">
            <Button
              variant="outline-danger"
              style={{ fontSize: 13 }}
              onClick={() => toggles.setToggle()}
              title="Permanently Delete Account"
              className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
            >
              <FaTrashAlt /> Permanently Delete Account
            </Button>
          </div>
        </div>
      </div>
      <PermanentDeleteAccount
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title="Permanent Delete Account"
        isDark={isDark}
        auth={auth}
      />
      <RegenerateSecretKey
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title="Re-generate Secret key"
        isDark={isDark}
        auth={auth}
      />
      <ChangeEmail
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title="Change Email"
        isDark={isDark}
        currentEmail={currentUserData?.email}
        auth={auth}
      />
    </>
  );
};

export default ProfileDetails;
